export enum UtilityRateCurrency {
  BGN = 'BGN',
  EUR = 'EUR',
  USD = 'USD',
}
